// extracted by mini-css-extract-plugin
export default {"container":"ol-z","blurb":"pl-z","links":"ql-z"};